export default "__VITE_ASSET__f8a20914__"